export default ({ COLORS }) => ({
  titleLink: {
    color: COLORS.BLUE.NORMAL,
    fontWeight: 'bold',
    textDecoration: 'none'
  },
  thumbnail: {
    padding: '10px',
    '& > a': {
      display: 'block',
      position: 'relative',
      background: '#ececec',
      border: '1px solid #ececec',
      width: '100%',
      paddingBottom: '133%',
      borderRadius: '8px',
      overflow: 'hidden',
      '& > span': {
        position: 'absolute',
        left: '0',
        top: '0',
        backgroundSize: 'cover',
        width: '100%',
        height: '100%'
      }
    }
  },
  inPart: {
    '& svg': {
      fontSize: '.8em',
      marginLeft: '2px'
    }
  }
})
